export const graphicFileTypesItems = [
  {
    label: "PNG",
    value: ".png",
  },
  {
    label: "JPG",
    value: ".jpeg, .jpg",
  },
  {
    label: "GIF",
    value: ".gif",
  },
  {
    label: "EPS",
    value: ".eps",
  },
  {
    label: "AI",
    value: ".ai",
  },
  {
    label: "SVG",
    value: ".svg",
  },
];

export const graphicFileTypesValues = graphicFileTypesItems.map(
  ({ value }) => value
);

export const fileTypesItems = [
  ...graphicFileTypesItems,
  {
    label: "PDF",
    value: ".pdf",
  },
  {
    label: "DOC, DOCX",
    value: ".doc, .docx",
  },
  {
    label: "XLSX, CSV",
    value: ".xlsx, .csv",
  },
  {
    label: "PPT, PPTX",
    value: ".ppt, .pptx",
  },
  { label: "MOV, MP3, MP4", value: ".mov, .mp3, .mp4" },
  { label: "ZIP", value: ".zip" },
];

export const fileDimensionsValidTypes = [".png", ".jpeg, .jpg", ".svg"];

// Accepts either a nested `fileDimensions.{widthPixels,heightPixels}` or flat
// `fileDimensionsWidth`/`fileDimensionsHeight`; reads the first present pair.
type FileDimensionsLike = {
  responseType?: string | null;
  fileTypes?: string[] | null;
  fileDimensions?: { widthPixels?: number; heightPixels?: number } | null;
  fileDimensionsWidth?: number | null;
  fileDimensionsHeight?: number | null;
};

export const hasValidFileDimensions = (task: FileDimensionsLike) => {
  const width =
    task.fileDimensions?.widthPixels ?? task.fileDimensionsWidth ?? 0;
  const height =
    task.fileDimensions?.heightPixels ?? task.fileDimensionsHeight ?? 0;
  return (
    task.responseType === "files" &&
    task.fileTypes?.some((fileType) =>
      fileDimensionsValidTypes.includes(fileType)
    ) &&
    width > 0 &&
    height > 0
  );
};
